<script>
import abstractField from '../abstractField';
import {h, resolveComponent} from 'vue';

export default {
  name: 'field-label',
  mixins: [abstractField],
  render() {
    const cLabel = resolveComponent('c-label');
    return h(
      'span',
      {
        class: `form-builder-label ${this.schema.fieldClasses ? this.schema.fieldClasses : ''}`,
        id: this.schema.id,
        style: {
          width: this.schema.width,
          flex: `0 0 ${this.schema.width}`
        }
      },
      [
        h(
          cLabel,
          {
            weight: this.schema.weight,
            color:
              this.schema.placeholder && !this.value
                ? this.$theme.COLOR.UI.UI07
                : this.$theme.COLOR.UI.UI01,
            style: {
              ...this.schema.style
            }
          },
          [this.value || this.schema.placeholder]
        )
      ]
    );
  }
};
</script>

<style lang="scss">
.c-form-group {
  .form-builder-label {
    padding-top: 6px;

    .c-label {
      word-break: break-all;
    }
  }

  &-view {
    .form-builder-label {
      padding-top: 0px;
    }
  }
}
</style>
